import { getInvitedUsers, trialUser, postUserByInvitation, acceptChangeSchoolInvitation, getUserByInvitation, sendTrialInvitationsService, externalTrialUser, requestInvitationResend } from '../../services/UserService'
import { baseTrialUser, maxInvitations } from '../../utils/constants'
import successIcon from '../../assets/il_mail_newpassword.svg'
import { deepCopy } from '../../utils/object'
import { isError } from '../../utils/api'
import router, { routes } from '../../router'
import { i18n } from '../../main'
import LocalStorageService from '../../services/LocalStorageService'

export default {
  state: {
    emailsToInvite: [],
    emailsWithState: [],
    invitedEmails: {},
    trialUser: deepCopy(baseTrialUser),
    trialError: ''
  },

  mutations: {
    setEmail(state, { inputEmail, inputIndex }) {
      state.emailsToInvite[inputIndex] = inputEmail
    },
    setInvitedEmails(state, invitedEmails) {
      state.invitedEmails = invitedEmails
    },
    setEmailList(state, emailList) {
      state.emailsToInvite = emailList
    },
    setEmailListWithState(state, emailList) {
      state.emailsWithState = emailList
    },
    setTrialError(state, err) {
      state.trialError = err
    },
    changeTrialField(state, { field, value }) {
      state.trialUser[field] = value
    },
    changeTrialSchoolValue(state, { field, value }) {
      state.trialUser.school[field] = value
    },
    setNewTrialUser(state) {
      state.trialUser = deepCopy(baseTrialUser)
    },
    setNewTrialUserInvited(state, data) {
      const {
        schoolEducationalLevels,
        schoolTrial,
        schoolName,
        schoolId,
        schoolAddress,
        emailConfirmed,
        userVO,
        expired
      } = data
      const { userId, email, fullName, cellPhoneNumber, position } = userVO
      const school = {
        name: schoolName,
        id: schoolId,
        address: schoolAddress,
        impartedLevels: schoolEducationalLevels
      }
      state.trialUser.school = school
      state.trialUser.expired = expired
      state.trialUser.schoolTrial = schoolTrial
      state.trialUser.email = email
      state.trialUser.repeatEmail = email
      state.trialUser.emailConfirmed = emailConfirmed
      state.trialUser.userId = userId
      if (emailConfirmed === true) {
        state.trialUser.fullName = fullName
        state.trialUser.cellPhoneNumber = cellPhoneNumber
        state.trialUser.position = position
      }
    }
  },

  actions: {
    updateTrialEmail({ commit }, payload) {
      commit('setEmail', payload)
    },
    changeTrialUserField({ commit }, payload) {
      commit('changeTrialField', payload)
    },
    changeTrialSchoolValue({ commit }, payload) {
      commit('changeTrialSchoolValue', payload)
    },
    setError({ commit }, data) {
      commit('setTrialError', data)
    },
    setNewTrialUser({ commit }) {
      commit('setNewTrialUser')
    },
    async getInvitedUsers({ commit }) {
      const response = await getInvitedUsers()
      commit('setInvitedEmails', response.data)
      const emailListWithState = [
        ...(response.data.confirmed ? response.data.confirmed.map(element => ({ email: element, state: 'confirmed' })) : []),
        ...(response.data.pending ? response.data.pending.map(element => ({ email: element, state: 'pending' })) : []),
        ...new Array(maxInvitations - response.data.count).fill({ email: '', state: '' })
      ]
      commit('setEmailListWithState', emailListWithState)
      const emailListNoState = emailListWithState.map(element => element.email)
      commit('setEmailList', emailListNoState)
    },
    async sendTrialInvitations({ commit }) {
      commit('show', { element: 'fullPageLoader' })
      const response = await sendTrialInvitationsService(this.state.trial.emailsToInvite).catch(e => e.response)
      commit('hide', { element: 'fullPageLoader' })
      if (!isError(response.status)) {
        commit('hide', { element: 'trialInviteModal' })
        commit('show', { element: 'sentInvitationsModal' })
      }
    },
    async submitTrialUser({ commit }) {
      commit('show', { element: 'fullPageLoader' })
      commit('changeTrialField', { field: 'userName', value: this.state.trial.trialUser.email })
      const response = await trialUser(this.state.trial.trialUser).catch(e => e.response)
      const isSuccessful = !isError(response.status)
      if (isSuccessful) commit('show', { element: 'activeAccountModal' })
      else commit('setTrialError', response.data)
      commit('hide', { element: 'fullPageLoader' })
    },
    async submitExternalTrialUser({ commit, dispatch }) {
      commit('show', { element: 'fullPageLoader' })
      commit('changeTrialField', { field: 'userName', value: this.state.trial.trialUser.email })
      const response = await externalTrialUser(this.state.trial.trialUser).catch(e => e.response)
      const isSuccessful = !isError(response.status)
      if (isSuccessful) {
        const token = response.data.token
        LocalStorageService.setAuthToken(token)
        commit('loginUser')
      } else commit('setTrialError', response.data)
      commit('hide', { element: 'fullPageLoader' })
      return isSuccessful
    },
    async getUserTrialInfoByInvitation({ commit, state }, payload) {
      const response = await getUserByInvitation(payload).catch(e => e.response)
      const success = !isError(response.status)
      if (!success) return router.push({ name: routes.usedToken })
      else {
        commit('setNewTrialUserInvited', response.data)
        if (state.trialUser.expired) {
          router.push({
            name: routes.expiredToken,
            params: { userId: state.trialUser.userId, schoolId: state.trialUser.school.id }
          })
        }
      }
    },
    async requestInvitationResend({ commit }, { userId, schoolId, locale }) {
      const response = await requestInvitationResend({ userId, schoolId, locale }).catch(e => e.response)
      const success = !isError(response.status)
      return { success, data: response.data }
    },
    async submitTrialUserInvitation({ commit }, data) {
      commit('show', { element: 'fullPageLoader' })
      const response = data.userVO.userId ? await acceptChangeSchoolInvitation(data).catch(e => e.response) : await postUserByInvitation(data).catch(e => e.response)
      commit('hide', { element: 'fullPageLoader' })
      if (!isError(response.status)) {
        commit('show', {
          element: 'successModal',
          props: {
            title: i18n.t('trial.done'),
            icon: successIcon,
            onClose: () => router.push({ name: routes.home })
          }
        })
      }
    }
  }
}
